import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import Style from "@/components/VisualSearch/v1/ResultPage/ImageCropper/index.module.scss"
import incorrect from "@/public/images/tooltip_questionmark.svg"
import vs from "@/public/images/visual_search_small.svg"
import ImageCropPicker from "@/components/VisualSearch/v1/ResultPage/ImageCropPicker/index.jsx"
import { getTranslations } from "@/components/VisualSearch/localization"
import { useTranslation } from "next-i18next"

const ImageCropper = props => {
  const { image, setSection, product, setOutput, output, loading } = props
  const { t } = useTranslation()
  const { incorrectMatch, newSearch } = getTranslations(t)
  const [imagePreview, setImagePreview] = useState(null)
  useEffect(() => {
    if (image) {
      const imageUrl = URL.createObjectURL(image?.file)
      setImagePreview(imageUrl)
    }
  }, [image])

  return (
    <div className={`${Style.ImageCropperWrapper}`}>
      <div className="image-cropper mb-5">
        <div className={`outer-image-section position-relative`}>
          <ImageCropPicker
            loadedState={true}
            imageUrl={imagePreview}
            imageData={image}
            product={product}
            setOutput={setOutput}
            output={output}
            loading={loading}
          />
        </div>
        <div className="incorrect-search">
          <div className="d-flex">
            <img alt="incorrect-match" src={incorrect?.src} />
            <p onClick={() => setSection("categotory")}>{incorrectMatch}</p>
          </div>
          <div className="d-flex">
            <img alt="new-search" src={vs?.src} />
            <p onClick={() => setSection("upload")}>{newSearch}</p>
          </div>
        </div>
      </div>
    </div>
  )
}
ImageCropper.propTypes = {
  image: PropTypes.object.isRequired,
  setSection: PropTypes.func.isRequired,
  product: PropTypes.object,
  setOutput: PropTypes.func.isRequired,
  output: PropTypes.object,
  loading: PropTypes.bool.isRequired,
}

export default ImageCropper
